$.ProjectImporter = function(options) {
	var obj = new Object;

	$.extend(obj, {
		openCreateOrganizationDialog: function (role) {
			if (!role) {
				role = 'vertically_integrated_role';
			}

			let form = $('<form class="ui content form">');
			form.append('<h4 class="ui dividing header">Information</h4>');

			let formRules = {
				orgName: {
					identifier: 'orgName',
					rules: [
						{type: 'empty'}
					]
				},
				shortCode: {
					identifier: 'shortCode',
					rules: [
						{
							type: 'maxLength[9]'
						}
					]
				}
			};
			var orgNameBox = $('<div class="field"><label>Name</label><input placeholder="Organization Name" type="text" name="orgName" /></div></div>');
			var orgShortCodeBox = $('<div class="field"><label>Short Code (max 9 chars)</label><input placeholder="11011" type="text" name="shortCode" /></div></div>');
			$('<div class="two fields">').append(orgNameBox).append(orgShortCodeBox).appendTo(form);

			let parentSearch;
			// eslint-disable-next-line
			if(role == 'studio_role' || role === 'create_studio') {
				
			} else if ($.isManager === false) {
				parentSearch = $('<div class="field"><label>Parent Studio</label></div>');
				parentSearch.append(new $.pickOrganizationDropdown({
					role: 'studio_role'
				}));
				form.append(parentSearch);

				formRules.parentOrganization = {
					identifier: 'organization',
					rules: [
						{type: 'visibleEmpty'}
					]
				};
			} else if (role == 'vertically_integrated_role' || role == 'lab_role') {
				var orgRoleBox = $('<div class="field"><label>Role</label><select class="ui dropdown" name="orgRole"><option value="">Role</option><option value="studio_role">Studio</option><option value="customer_role">Customer</option></select></div>');
				orgRoleBox.find('.dropdown').dropdown({
					onChange: function (value, text) {
						if (value == 'studio_role') {
							parentSearch.hide();
						} else {
							parentSearch.show();
						}
					}
				});
				form.append(orgRoleBox);

				parentSearch = $('<div class="field" style="display: none;"><label>Parent Studio</label></div>');
				parentSearch.append(new $.pickOrganizationDropdown({
					role: 'studio_role'
				}));
				form.append(parentSearch);

				orgRoleBox.find('.dropdown').dropdown('set selected', 'customer_role');

				$.extend(formRules, {
					orgRole: {
						identifier: 'orgRole',
						rules: [
							{type: 'empty'}
						]
					},
					parentOrganization: {
						identifier: 'organization',
						rules: [
							{type: 'visibleEmpty'}
						]
					}
				});
			} else {
				throw 'Invalid organization role';
			}

			form.SettingsBuilder([
				{
					type: 'section',
					description: 'Contact Information',
					settings: [
						{
							id: 'contactName',
							type: 'text',
							description: 'Contact Name'
						},
						{
							id: 'contactEmail',
							type: 'email',
							description: 'Email'
						},
						{
							id: 'contactPhone',
							type: 'text',
							description: 'Phone Number'
						}
					]
				}
			], {
				formRules: formRules,
				onSubmit: function() {
					dialog.find('.actions').find('.primary.button').click();
				}
			});

			var me = this;
			var dialog = $('<div class="ui modal"><i class="close icon"></i><div class="header">Create Organization</div></div>')
				.append(form)
				.append('<div class="actions"><div class="ui deny button">Cancel</div><div class="ui approve primary button">OK</div></div>')
				.modal({
					onApprove: function () {
						if (!form.form('validate form')) {
							return false;
						}

						var orgName = orgNameBox.find('input').val();
						var orgShortCode = orgShortCodeBox.find('input').val();
						var orgRole;
						if (orgRoleBox) {
							orgRole = orgRoleBox.find('select').val();
						} else if(role === 'create_studio') {
							orgRole = 'studio_role';
						} else {
							orgRole = 'customer_role';
						}

						var parentOrg = null;
						if (parentSearch && parentSearch.is(':visible')) {
							parentOrg = parentSearch.find('input').val();
						}

						var extras = {
							shortCode: orgShortCode
						};
						form.getChanges().forEach(function(change) {
							extras[change.id] = change.value;
						});

						me.createOrganization(orgName, orgRole, parentOrg, extras);
						return false;
					},
					onHidden: function () {
						me.dialog = null;
						$(this).remove();
					},
					closable: false
				}).modal('show');
			this.dialog = dialog;
		},
		createOrganization: function (orgName, orgRole, parentOrg, extras) {
			this.dialog.find('.content').removeClass('form success').html('<div class="ui active inverted dimmer"><div class="ui text loader">Loading</div></div>');
			this.dialog.find('.actions').empty();

			$.ajax({
				url: 'ajax/createOrganization.php',
				data: $.extend({
					name: orgName,
					role: orgRole,
					parent: parentOrg
				}, extras),
				dataType: 'json',
				type: 'POST',
				success: function () {
					$.AlertSuccess('Successfully created organization.  You may now add projects to ' + orgName + '.');
				},
				error: function (response) {
					var duplicateName, duplicateType = 'name', invalidName;
					if (response && response.responseText) {
						if (response.responseText.indexOf('has already been taken') != -1) {
							if(response.responseText.indexOf('short code') !== -1) {
								duplicateType = 'short code';
								duplicateName = extras.shortCode;
							} else {
								duplicateName = orgName;
							}
						} else if (response.responseText.indexOf('Invalid parent organization') != -1) {
							invalidName = parentOrg;
						}
					}


					if (duplicateName) {
						$.Alert('Error', 'An organization with the ' + duplicateType + ' ' + duplicateName + ' already exists. Please choose a different ' + duplicateType + '.');
					} else if (invalidName) {
						$.Alert('Error', 'There exists no organization with the name ' + invalidName + '.  Please choose a valid parent organization.');
					} else {
						$.Alert('Error', 'Failed to create new organization');
					}
				}
			});
		},

		openCreateProjectDialog: function (options) {
			options = $.extend({}, options);

			var form = $('<form class="ui content form">');
			var fields = $('<div class="two fields">').appendTo(form);

			var organizationField = $('<div class="field"><label>Organization</label></div>');
			var organizationDropdown = new $.pickOrganizationDropdown({
				role: 'customer_role'
			});
			organizationField.append(organizationDropdown);
			fields.append(organizationField);

			var projectName = $('<div class="field"><label>Name</label><input placeholder="Project Name" type="text" name="projectName" /></div></div>');
			fields.append(projectName);

			var projectShortCode = $('<div class="field"><label>Short Code</label><input placeholder="12345" type="text" name="projectShortCode" /></div></div>');
			fields.append(projectShortCode);

			var seasonField = $('<div class="field"><label>Season</label></div>');
			var seasonDropdown = new $.pickDataDropdown({
				id: 'season',
				title: 'Seasons',
				data: 'seasons',
				autoSelectFirst: true,
				ajax: $.getPlicAPI({
					method: 'organizations/' + $.PlicOrgId + '/seasons',
					type: 'GET'
				})
			});
			seasonField.append(seasonDropdown);
			fields.append(seasonField);

			if(options.bookFormat) {
				var bookFormatField = $('<div class="field"><label>Book Format</label></div>');
				var bookFormatDropdown = new $.pickDataDropdown({
					id: 'bookFormat',
					title: 'Book Formats',
					data: 'data',
					itemId: 'formatId',
					autoSelectFirst: true,
					ajax: {
						url: 'ajax/bookFormats.php'
					},
					defaultValue: $.defaultBookFormatId
				});
				bookFormatField.append(bookFormatDropdown);
				fields.append(bookFormatField);
			}

			if(options.workflows) {
				var workflowsField = $('<div class="field"><label>Workflows</label></div>');
				var workflowsDropdown = new $.pickDataDropdown({
					id: 'workflows',
					title: 'Workflows',
					data: 'workflows',
					ajax: $.getPlicAPI({
						method: 'organizations/' + $.PlicOrgId + '/workflows',
						type: 'GET',
						params: {
							filter: {
								tagged_plic_app_id: $.plicSlug
							}
						}
					}),
					defaultValue: $.defaultWorkflowId,
					multiple: true
				});
				workflowsField.append(workflowsDropdown);
				fields.append(workflowsField);
			}

			var plicAppsField = $('<div class="field"><label>PLIC Apps ' +
				'<span data-tooltip="Limit the PLIC Apps this project is visible to.  Leave blank to allow all."><i class="blue help icon"></i></span>' +
				'</label></div>');
			var plicAppsDropdown = new $.pickDataDropdown({
				id: 'plicAppWhitelist',
				title: 'PLIC Apps',
				items: $.activePlicApps.map(function(app) {
					return {
						id: app.slug,
						name: app.name
					}
				}),
				multiple: true,
				search: true
			});
			plicAppsField.append(plicAppsDropdown);
			fields.append(plicAppsField);

			if($.projectSettings) {
				form.append('<h3 class="ui dividing header">Project Settings</h3>');
				form.SettingsBuilder($.projectSettings, {
					formRules: {
						projectName: {
							identifier: 'projectName',
							rules: [
								{type: 'empty'}
							]
						},
						projectShortCode: {
							identifier: 'projectShortCode',
							rules: [
								{type: 'maxLength[9]'}
							]
						},
						organizationName: {
							identifier: 'organization',
							rules: [
								{
									type: 'empty'
								}
							]
						},
						bookFormat: {
							identifier: 'bookFormat',
							rules: [{
								type: 'empty'
							}]
						}
					},
					autoFormatColumns: true,
					hideCollapsed: true,
					onSubmit: function() {
						dialog.find('.actions').find('.primary.button').click();
					}
				});
			} else {
				form.addClass('settings-builder').form({
					fields: {
						projectName: 'empty',
						organization: 'empty'
					}
				}).on('submit', function() {
					dialog.find('.actions').find('.primary.button').click();
				});
			}

			var me = this;
			var dialog = $('<div class="ui modal"><i class="close icon"></i><div class="header">Create Project</div></div>')
				.append(form)
				.append('<div class="actions"><div class="ui deny button">Cancel</div><div class="ui approve primary button">OK</div></div>')
				.modal({
					onApprove: function () {
						if (!form.form('validate form')) {
							return false;
						}

						var orgId = organizationDropdown.dropdown('get value');
						var orgName = organizationDropdown.dropdown('get text');
						var jobName = projectName.find('input').val();
						var seasonId = $(seasonDropdown).dropdown('get value');

						var plicAppsWhitelist = plicAppsField.find('input').val();
						if(plicAppsWhitelist) {
							plicAppsWhitelist = plicAppsWhitelist.split(',');
						} else {
							plicAppsWhitelist = null;
						}

						var extras = {
							shortCode: projectShortCode.find('input').val(),
							plicAppWhitelist: plicAppsWhitelist
						};
						if(options.bookFormat) {
							extras.bookFormatId = $(bookFormatDropdown).dropdown('get value');
						}
						if(options.workflows) {
							extras.workflows = $(workflowsDropdown).dropdown('get value');
						}

						var settings = null;
						if (form.getChanges) {
							settings = form.getChanges();
						}

						me.createProject(orgId, orgName, jobName, seasonId, extras, settings);
					},
					onHidden: function () {
						$(this).remove();
					},
					closable: false
				}).modal('show');
			this.dialog = dialog;
		},
		createProject: function (orgId, orgName, jobName, seasonId, extras, settings) {
			var me = this;
			if (this.loader) {
				this.loader.addClass('active');
			}
			$.ajax({
				url: 'ajax/createJob.php',
				data: $.extend({
					org: orgId,
					name: jobName,
					seasonId: seasonId,
					settings: settings
				}, extras),
				dataType: 'json',
				type: 'POST',
				success: function (data) {
					if (me.onInsertProject) {
						me.onInsertProject(data);
					}

					if (me.loader) {
						me.loader.removeClass('active');
					}
				},
				error: function (response) {
					var duplicateName, duplicateType = 'name';
					if (response && response.responseText) {
						if (response.responseText.indexOf('has already been taken') != -1) {
							if(response.responseText.indexOf('short code') !== -1) {
								duplicateType = 'short code';
								duplicateName = extras.shortCode;
							} else {
								duplicateName = jobName;
							}
						}
					}

					if (duplicateName) {
						$.Alert('Error', 'There already exists a project with the ' + duplicateType + ' ' + duplicateName + '.  Please choose a different ' + duplicateType + '.');
					} else {
						$.Alert('Error', 'Failed to create new project');
					}

					if (me.loader) {
						me.loader.removeClass('active');
					}
				}
			});
		},
		deleteProject: function (job, options) {
			var button, onSuccess;
			if (options) {
				if (options.button) {
					button = options.button;
				}
				if (options.onSuccess) {
					onSuccess = options.onSuccess;
				}
			}

			if (button) {
				button.removeClass('negative').addClass('loading');
			}

			$.plicAPI({
				method: 'projects/' + job.plicProjectId,
				type: 'DELETE',
				success: function () {
					if(button) {
						button.removeClass('loading');
					}

					if(onSuccess) {
						onSuccess();
					}
				},
				error: function () {
					if (button) {
						button.removeClass('loading').addClass('negative');
					}
				}
			});
		},

		loadJobDetails: function (options, onComplete) {
			var chain = new $.ExecutionChain(onComplete);

			if(!options.templateFields) {
				chain.add($.getPlicAPI({
					method: 'projects/' + options.plicProjectId,
					success: function (data) {
						options.plicTemplateId = data.project.project_template_id;

						chain.add($.getPlicAPI({
							method: 'project-templates/' + options.plicTemplateId,
							accept: 'application/vnd.plic.io.v1+json',
							success: function (data) {
								options.template = data.project_template;
								options.templateFields = options.template.subject_fields;
							},
							error: function () {
								$.Alert('Error', 'Failed to get job details to start upload');
							}
						}));
					},
					error: function () {
						$.Alert('Error', 'Failed to get job details to start upload');
					}
				}));
			}

			if(!options.plicSubjectAlbumId) {
				chain.add($.getPlicAPI({
					method: 'albums',
					params: {
						parent_resource_type: 'project',
						parent_resource_id: options.plicProjectId,
						tag: 'Subject Photos'
					},
					type: 'GET',
					success: function (data) {
						var albums = data.albums;

						if (albums.length) {
							options.plicSubjectAlbumId = albums[0].id;
						} else {
							chain.add($.getPlicAPI({
								method: 'albums',
								params: {
									album: {
										name: 'Subject Photos',
										tags: [
											'Subject Photos'
										]
									},
									parent_resource_type: 'project',
									parent_resource_id: options.plicProjectId
								},
								success: function (data) {
									options.plicSubjectAlbumId = data.album.id;
								},
								error: function () {
									$.Alert('Error', 'Failed to get job details to start upload');
								}
							}));
						}
					},
					error: function () {
						$.Alert('Error', 'Failed to get job details to start upload');
					}
				}));
			}

			chain.done();
		}
	});


	if(options && options.onInsertProject) {
		obj.onInsertProject = options.onInsertProject;
	}
	if(options && options.loader) {
		obj.loader = options.loader;
	}

	return obj;
};

$.pickOrganizationDropdown = (function() {
	return function(params) {
		if(!params) {
			params = {};
		}

		var organizationSearch = $('<div id="organizationSearch" class="ui fluid search loading button selection dropdown">');
		organizationSearch.append('<input name="organization" type="hidden">');
		organizationSearch.append('<span class="text">Organization</span>');
		organizationSearch.append('<div class="menu">');

		$.ajax({
			url: 'ajax/getOrganizations.php',
			dataType: 'json',
			data: params,
			success: function(data) {
				organizationSearch.removeClass('loading button');

				var orgs = data.results;
				var menu = organizationSearch.find('.menu');
				for(var i = 0; i < orgs.length; i++) {
					var org = orgs[i];
					menu.append($.createOrganizationDropdownItem(org));
				}
				organizationSearch.dropdown({
					fullTextSearch: 'exact',
					match: 'text',
					preserveHTML: false,
					onNoResults: function(search) {
						organizationSearch.find('input').val('');
					}
				});

				if(orgs.length === 1) {
					organizationSearch.dropdown('set selected', orgs[0].id);
				} else {
					organizationSearch.dropdown('set selected', $.OrgId);
				}
			},
			error: function() {
				organizationSearch.addClass('error');
			}
		});

		return organizationSearch;
	};
}) ();
$.createOrganizationDropdownItem = function(org) {
	var title = org.name ? org.name : org.title;
	if(org.shortCode) {
		title += ' - ' + org.shortCode;
	} else if(org.short_code) {
		title += ' - ' + org.short_code;
	}

	var item = document.createElement('div');
	item.className = 'item';
	item.setAttribute('data-value', org.id);
	item.setAttribute('data-text', title);
	item.value = org.id;
	$(item).data('item', org);

	var header = document.createElement('div');
	header.className = 'ui small header';
	item.appendChild(header);

	var role, orgIcon;
	switch(org.role) {
		case 'vertically_integrated_role':
			role = 'Vertically Integrated';
			orgIcon = 'building';
			break;
		case 'lab_role':
			role = 'Lab';
			orgIcon = 'lab';
			break;
		case 'studio_role':
			role = 'Studio';
			orgIcon = 'building';
			break;
		default:
			role = 'Customer';
			orgIcon = 'university';
	}

	var icon = document.createElement('i');
	icon.className = orgIcon + ' icon';
	header.appendChild(icon);

	var content = document.createElement('div');
	content.className = 'content';
	content.textContent = title;
	header.appendChild(content);

	var subHeader = document.createElement('div');
	subHeader.className = 'sub header';
	subHeader.textContent = role;
	content.appendChild(subHeader);

	return item;
};
$.createProjectDropdownItem = function(project) {
	var jobName = project.jobName;
	if(project.jobShortCode) {
		jobName += ' - ' + project.jobShortCode;
	}

	var organizationName = project.organizationName;
	if(project.organizationShortCode) {
		organizationName += ' - ' + project.organizationShortCode;
	}

	var div = $('<div class="item">')
		.attr('data-value', project.plicProjectId)
		.attr('data-text', jobName)
		.data('item', project);

	var header = $('<div class="ui small header">').appendTo(div);
	var content = $('<div class="content">').appendTo(header);
	content.text(jobName);
	$('<div class="sub header">').text(organizationName).appendTo(content);

	return div;
};

$.editUsersManagingOrgs = $.editUsersAccessRoles = function(user) {
	var button = $(this);
	button.removeClass('red');
	var form = $('<div class="ui content form">');

	if(user.orgRole != 'customer_role') {
		// Add toggle for whether or user is a "manager"
		var managerToggle = $('<div class="ui toggle checkbox"><input type="checkbox"/></div>');
		$('<div class="field"><label>Limit access to specific sub-organizations</label></div>').append(managerToggle).appendTo(form);

		// Create organizations search
		var organizationField = $('<div class="disabled field"><label>Organizations user can access</label></div>');
		var organizationSelect = new $.pickDataDropdown({
			id: 'user',
			title: 'Sub Organizations',
			data: ['organizations'],
			createItem: $.createOrganizationDropdownItem,
			search: true,
			multiple: true,
			defaultValue: user.managedOrganizationIds,
			ajax: $.getPlicAPI({
				method: `organizations/${user.plicOrgId}/organizations`,
				params: {
					traverse_sub_organizations: true
				},
				type: 'GET'
			}),
			onChange: function() {
				organizationField.removeClass('error');
				$(dialog).modal('refresh');
			},
			disabled: true
		});

		organizationField.append(organizationSelect);
		form.append(organizationField);

		managerToggle.checkbox({
			onChecked: function() {
				organizationField.removeClass('disabled');
				organizationSelect.enable();
			},
			onUnchecked: function() {
				organizationField.addClass('disabled');
				organizationSelect.disable();
			}
		});
		if(user.managedOrganizationIds) {
			managerToggle.checkbox('check');
		}
	}


	// Add toggle for whether or user can view all apps
	var limitPlicAppsToggle = $('<div class="ui toggle checkbox"><input type="checkbox"/></div>');
	$('<div class="field"><label>Limit access to specific Plic Apps</label></div>').append(limitPlicAppsToggle).appendTo(form);

	// Create PLIC Apps search
	var plicAppsField = $('<div class="disabled field"><label>PLIC Apps this user can access</label></div>');
	var plicAppsSelect = new $.pickDataDropdown({
		id: 'user',
		title: 'PLIC Apps',
		items: $.merge([
			{
				id: 'plic-io',
				name: 'PLIC IO'
			}
		], $.activePlicApps.map(function(app) {
			return {
				id: app.slug,
				name: app.name
			}
		})),
		search: true,
		multiple: true,
		defaultValue: user.plicAppWhitelist,
		onChange: function() {
			plicAppsField.removeClass('error');
		},
		disabled: true
	});

	plicAppsField.append(plicAppsSelect);
	form.append(plicAppsField);

	limitPlicAppsToggle.checkbox({
		onChecked: function() {
			plicAppsField.removeClass('disabled');
			plicAppsSelect.enable();
		},
		onUnchecked: function() {
			plicAppsField.addClass('disabled');
			plicAppsSelect.disable();
		}
	});
	if(user.plicAppWhitelist) {
		limitPlicAppsToggle.checkbox('check');
	}

	var dialog = $('<div class="ui modal"><i class="close icon"></i><div class="header">Edit User\'s Access</div></div>')
		.append(form)
		.append('<div class="ui inverted dimmer"><div class="ui text loader">Loading</div></div>')
		.append('<div class="actions"><div class="ui deny button">Cancel</div><div class="ui approve primary button">OK</div></div>')
		.modal({
			closable: false,
			onApprove: function() {
				var limitPlicApps = limitPlicAppsToggle.checkbox('is checked');
				var limitPlicAppsList = null;
				if(limitPlicApps) {
					limitPlicAppsList = plicAppsSelect.getSelectedValue();
				}

				var postData = {
					account: {
						enable_plic_app_whitelist: limitPlicApps,
						plic_app_whitelist_slugs: limitPlicAppsList
					}
				};

				if(managerToggle) {
					var isManager = managerToggle.checkbox('is checked');
					let subOrgs = null;
					if(isManager) {
						subOrgs = organizationSelect.getSelectedValue();
						if(!subOrgs.length) {
							organizationField.addClass('error');
							return false;
						}
					}

					$.extend(postData, {
						manages_own_organization: !isManager,
						managed_sub_organization_ids: subOrgs
					});
				}

				button.addClass('loading button');
				$.plicAPI({
					method: 'accounts/' + user.accountId,
					params: postData,
					type: 'PUT',
					success: function() {
						user.plicAppWhitelist = limitPlicAppsList;
						if(managerToggle) {
							if(postData.manages_own_organization) {
								user.managedOrganizationIds = null;
							} else {
								user.managedOrganizationIds = postData.managed_sub_organization_ids;
							}
						}
						button.removeClass('loading button');

						if($.userTable) {
							$.userTable.dataTable().fnDisplayUpdatedData(user);
						}
					},
					error: function() {
						button.removeClass('loading button').addClass('red');
					}
				});
			},
			onHidden: function() {
				$(this).remove();
			}
		}).modal('show');
};